<script>
  import ReportingArticle from 'src/pc/pages/ReportingArticle'
  import PageLayout from '../layouts/PageLayout'
  import SubPageLayout from '../layouts/SubPageLayout'
  import DisplayContainer from '../components/DisplayContainer'
  import ReportInfo from '../components/ReportInfo'
  export default {
    extends: ReportingArticle,
    data () {
      return {
        isHidden: true
      }
    },
    components: {
      SubPageLayout,
      PageLayout,
      DisplayContainer,
      ReportInfo
    },
    computed: {
      getAccess() {
        return 'mobile'
      }
    }
  }
</script>

<style>
  .reporting_article .con_wrapper {
    width: 100%;
    padding-top: 25px;
    padding-bottom: 50px;
  }
  .reporting_article .report .data {
    padding-bottom: 22px;
    margin-bottom: 25px;
  }
  .reporting_article .report .subj {
    font-size: 22px;
    font-weight: 800;
    letter-spacing: -0.035em;
  }
  .reporting_article .report .date_area {
    font-size: 11px;
    margin-top: 20px;
    padding-top: 30px;
    position: relative;
  }
  .reporting_article .report .date_area .date:after {
    content: "" !important;
  }
  .reporting_article .report .date_area .level {
    display: block;
  }
  .reporting_article .report .date_area .editor {
    position: absolute;
    top: 0;
    left: 0;
    font-size: 12px;
    margin-left: 0;
  }
  .reporting_article .report .date_area .editor .img {
    width: 22px;
    height: 22px;
    transform: translateY(-4px);
  }
  .reporting_article .report .date_area .editor .name {
    padding-left: 7px;
  }
  .reporting_article .report .detail_con .con_view {
    font-size: 16px;
    font-weight: 300;
    line-height: 1.8em;
    padding-bottom: 50px;
  }
  .reporting_article .report .detail_con .copy {
    line-height: 1.6em;
  }
  .reporting_article .report .detail_con .copy span {
    display: block;
  }
  .reporting_article .report .detail_con .tag {
    position: relative;
    padding-left: 50px;
  }
  .reporting_article .report .detail_con .tag .h_tags  {
    font-size: 13px;
    line-height: 1.0em;
  }
  .reporting_article .report .detail_con .tag .h_tags .tit {
    font-weight: 700;
  }
  .reporting_article .report .detail_con .tag .h_tags a {
    margin: 0 10px 12px;
  }

  .reporting_article .report .detail_con .editor {
    padding: 25px 15px 25px 75px;
    font-size: 12px;
    margin: 25px 0;
    display: inline-flex;
    width: 100%;
    flex-direction: column;
  }
  .reporting_article .report .detail_con .editor .img {
    position: absolute;
    top: 50%;
    left: 25px;
    transform: translate(0, -50%);
  }
  .reporting_article .report .detail_con .editor .img img {
    width: 35px;
    height: 35px;
  }
  .reporting_article .report .detail_con .editor p {
    margin: 0;
  }
  .reporting_article .report .detail_con .editor p.name {
    align-self: flex-start;
  }
  .reporting_article .report .detail_con .editor p.position {
    align-self: flex-start;
  }
  .reporting_article .report .detail_con .editor a {
    right: 25px;
    top: 50%;
    transform: translate(0, -50%);
  }
  .reporting_article .detail_con table {
    width: calc(100vw - 40px) !important;
    white-space: nowrap;
    overflow-x: scroll;
    display: block;
  }
  .reporting_article .detail_con table tbody {
    display: table;
    width: 100%;
  }
  .reporting_article .detail_con table td {
    padding: 8px 2.0vw;
    font-size: 0.80em;
  }
  .reporting_article .detail_con table td:first-child {
    padding-left: 4vw;
  }
  .reporting_article .detail_con table td:last-child {
    padding-right: 4vw;
  }
  .reporting_article .detail_con p.box {
    padding: 15px 20px;
  }
  .reporting_article .detail_con .telegram {
    padding: 15px 10px !important;
    margin: 20px 0 !important;
  }
  .reporting_article .detail_con .telegram p {
    margin: 0 7px !important;
    line-height: 1.6em !important;
    font-size: 12px !important;
  }
  .reporting_article .detail_con .telegram i.enter {
    display: block;
  }
  .reporting_article .detail_con .telegram p {
    margin: 0 5px;
  }
  .reporting_article .detail_con .telegram .img img {
    width: 36px;
    height: 36px;
  }
</style>
